import React from "react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from "src/components/ui/sheet";
import { ContactForm } from "./ContactForm";
import {
  useCreateContact,
  useUpdateContact,
} from "../hooks/useContacts";
import { useToast } from "src/components/ui/toast";

export function ContactDrawer({
  open,
  onClose,
  contact,
  onSuccess,
}) {
  const isEdit = !!contact;
  const { toast } = useToast();

  const createHook = useCreateContact();
  const updateHook = useUpdateContact();

  const isPending = createHook.isPending || updateHook.isPending;

  async function handleSubmit(data) {
    const payload = Object.fromEntries(
      Object.entries(data).filter(
        ([, v]) => v !== "" && v !== null && v !== undefined
      )
    );

    try {
      if (isEdit) {
        await updateHook.mutate(contact.id, payload);
        toast({ title: "Contact updated", description: payload.name });
      } else {
        await createHook.mutate(payload);
        toast({ title: "Contact created", description: payload.name });
      }
      onSuccess?.();
      onClose();
    } catch (errors) {
      const msg = Array.isArray(errors)
        ? errors[0]
        : errors?.message || "Something went wrong";
      toast({ variant: "destructive", title: "Error", description: msg });
    }
  }

  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent side="right" className="flex flex-col p-0 sm:max-w-[480px]">
        <SheetHeader>
          <SheetTitle>
            {isEdit ? "Edit Contact" : "New Contact"}
          </SheetTitle>
          <SheetDescription>
            {isEdit
              ? "Update the contact details below."
              : "Fill in the details to create a new contact."}
          </SheetDescription>
        </SheetHeader>

        <ContactForm
          contact={contact}
          onSubmit={handleSubmit}
          onCancel={onClose}
          isPending={isPending}
        />
      </SheetContent>
    </Sheet>
  );
}
